const { EntityRoot } = require('@octadesk/entity')

class PhoneContact extends EntityRoot {
  constructor(document) {
    super(document)
    this.number = document.number
    this.countryCode = document.countryCode || '55'
    this.type = typeof document.type === 'undefined' ? 1 : document.type
  }
}

module.exports = PhoneContact
